import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  IDemoStingerValues,
  LabelName,
} from '../../../../dto/demoStingerFulfilment.dto';
import {commonDateFormat} from '../../../../Service/CommonService';
type Props = {
  values: IDemoStingerValues;
};
export const truncateText = (text: string, maxLength: number) => {
  return text?.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};
const types = [
  'GameTime Demo',
  'GT Title Sponsor Demo',
  'Neptune Radio Demo',
  'SchoolZone Demo',
  'TNN Demo',
];
// Reusable renderer for cells
const renderField = (
  label: string,
  value?: string | number | null,
  maxLength = 30,
) => {
  if (!value) return null;

  return (
    <TableCell>
      <Typography variant='subtitle1' className='text-white-50'>
        {label}
      </Typography>
      <Tooltip title={String(value)}>
        <Typography aria-label={label}>
          {truncateText(String(value), maxLength)}
        </Typography>
      </Tooltip>
    </TableCell>
  );
};

const DemoStingerContent = ({values}: Props) => {
  return (
    <TableContainer>
      <Table
        sx={{
          '.MuiTableCell-root, .MuiTableRow-root': {
            border: 'none !important',
            padding: '6px 0',
          },
        }}>
        <TableBody>
          <TableRow>
            {renderField(
              'Demo Stinger Fulfillment Type',
              types[values.request_type - 1],
            )}
            {renderField(LabelName[values.request_type] ?? 'Name', values.name)}
            {renderField('Category', values.category)}
            {renderField('Prospect/Partner', values.prospect_partner)}
            {values.request_type === 3 &&
              renderField('Radio Station Name', values.station_name)}
            {[1, 5].includes(values.request_type) &&
              values.mascot &&
              renderField('Mascot', values.mascot)}
          </TableRow>

          <TableRow>
            {renderField(
              'Standard/Rush',
              values.option === 1 ? 'Standard' : 'Rush',
            )}
            {values.request_type === 5 &&
              renderField('Advertiser', values.advertiser)}
            {values.request_type === 5 &&
              renderField('Advertiser URL', values.advertiser_url)}
            {renderField('Date', commonDateFormat(values.date), 50)}
          </TableRow>

          <TableRow>
            <TableCell className='text-white-50'>
              <Typography variant='subtitle1'>Note</Typography>
            </TableCell>
            <TableCell colSpan={5}>
              <Typography aria-label='note'>
                <pre>{values.note}</pre>
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DemoStingerContent;
